import React from 'react';
import {
  GlobeIcon, ShieldIcon, TerminalIcon, CpuIcon, KeyboardIcon, CodeIcon,
  LightbulbIcon, RocketIcon, CheckIcon, DownloadIcon, SettingsIcon,
  MonitorIcon, FlameIcon, BugIcon, SparklesIcon, UserIcon, ZapIcon,
} from '../components/Icons.jsx';

const MAP = {
  globe: GlobeIcon,
  shield: ShieldIcon,
  terminal: TerminalIcon,
  cpu: CpuIcon,
  keyboard: KeyboardIcon,
  code: CodeIcon,
  bulb: LightbulbIcon,
  rocket: RocketIcon,
  check: CheckIcon,
  download: DownloadIcon,
  gear: SettingsIcon,
  monitor: MonitorIcon,
  flame: FlameIcon,
  bug: BugIcon,
  user: UserIcon,
  zap: ZapIcon,
};

export function DeckIcon({ name, size = 26 }) {
  const C = MAP[name] || SparklesIcon;
  return <C size={size} />;
}
